module.exports = __webpack_public_path__ + "img/normal.89298900.png";